import axios from "axios";
import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

const CategoryCreate = () => {
  const navigate = useNavigate();
  const initialFormState = {
    cat_name: "",
    cat_stock: "",
    cat_created_by: "",
    status: "",
  };

  const [categoryUser, setcategoryUser] = useState(initialFormState);
  const [categoryimage, setcategoryImage] = useState(null);
  const [previewImage, setPreviewImage] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleInput = (e) => {
    const { name, value } = e.target;
    setcategoryUser({ ...categoryUser, [name]: value });
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    setcategoryImage(file);
    if (file) {
      setPreviewImage(URL.createObjectURL(file));
    } else {
      setPreviewImage(null);
    }
  };

  const submitForm = async (e) => {
    e.preventDefault();

    // Basic validation (you can extend if needed)
    if (!categoryUser.cat_name?.trim()) {
      toast.error("Please enter category title");
      return;
    }

    const formData = new FormData();

    // Append both possible field names to maximize compatibility with the API.
    // The list endpoint returns `category_name`, so we send both `category_name` and legacy `cat_name`.
    formData.append("category_name", categoryUser.cat_name.trim());
    formData.append("cat_name", categoryUser.cat_name.trim());

    // created_by — send both variants
    formData.append("created_by", categoryUser.cat_created_by.trim());
    formData.append("cat_created_by", categoryUser.cat_created_by.trim());

    // stock and status (if API accepts them)
    if (categoryUser.cat_stock !== "") {
      formData.append("cat_stock", categoryUser.cat_stock);
      formData.append("stock", categoryUser.cat_stock);
    }
    if (categoryUser.status) {
      formData.append("status", categoryUser.status);
    }

    if (categoryimage) {
      // Many CodeIgniter APIs expect the file field called "image" or "cat_image".
      formData.append("cat_image", categoryimage);
      formData.append("image", categoryimage);
    }

    try {
      setIsSubmitting(true);
      const response = await axios.post(
        "https://cyberathon.com/multivendor/index.php/Api/Master_controller/add_main_category",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      // Your Postman response uses boolean `status: true`
      if (response.data && (response.data.status === true || response.data.status === "true")) {
        toast.success(response.data.message || "Category added successfully!");
        // Optionally, you could use response.data.category_id / response.data.image
        setcategoryUser(initialFormState);
        setcategoryImage(null);
        setPreviewImage(null);
        navigate("/category-list");
      } else {
        // If API returns success differently, try common fields
        const msg =
          response.data?.message ||
          response.data?.error ||
          "Failed to add category";
        toast.error(msg);
      }
    } catch (error) {
      console.error("Add category error:", error);
      toast.error("Something went wrong while adding category.");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="page-content">
      {/* Start Container Fluid */}
      <div className="container-fluid">
        {/* ========== Page Title Start ========== */}
        <div className="row">
          <div className="col-12">
            <div className="page-title-box">
              <h4 className="mb-0 fw-semibold">Create Category</h4>
              <ol className="breadcrumb mb-0">
                <li className="breadcrumb-item">
                  <a href="javascript: void(0);">Category</a>
                </li>
                <li className="breadcrumb-item active">Create Category</li>
              </ol>
            </div>
          </div>
        </div>

        {/* ========== Page Title End ========== */}
        <div className="row">
          <div className="col-xl-9 col-lg-8 ">
            <form onSubmit={submitForm} encType="multipart/form-data">
              <div className="card">
                <div className="card-header">
                  <h4 className="card-title">Add Image</h4>
                </div>
                <div className="card-body">
                  <div className="dropzone bg-light-subtle py-5">
                    <label className="form-label text-dark">Image</label>
                    <input
                      type="file"
                      id="cat-image"
                      className="form-control"
                      accept="image/*"
                      onChange={handleImageChange}
                    />
                    {previewImage && (
                      <img
                        src={previewImage}
                        alt="Preview"
                        className="mt-2"
                        style={{ width: "100px", height: "auto" }}
                      />
                    )}
                  </div>
                </div>
              </div>
              <div className="card">
                <div className="card-header">
                  <h4 className="card-title">General Information</h4>
                </div>
                <div className="card-body">
                  <div className="row">
                    <div className="col-lg-6">
                      <div className="mb-3">
                        <label className="form-label">Category Title</label>
                        <input
                          type="text"
                          id="cat_name"
                          name="cat_name"
                          onChange={handleInput}
                          value={categoryUser.cat_name}
                          className="form-control"
                          placeholder="Enter Title"
                        />
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <label className="form-label">Created By</label>
                      <select
                        className="form-control"
                        id="cat_created_by"
                        name="cat_created_by"
                        onChange={handleInput}
                        value={categoryUser.cat_created_by}
                        data-placeholder="Select Crater"
                      >
                        <option value="">Select Crater</option>
                        <option value="Seller">Seller</option>
                        <option value="Admin">Admin</option>
                        <option value="Other">Other</option>
                      </select>
                    </div>

                    <div className="col-lg-6">
                      <div className="mb-3">
                        <label className="form-label">Stock</label>
                        <input
                          type="number"
                          id="cat_stock"
                          name="cat_stock"
                          onChange={handleInput}
                          value={categoryUser.cat_stock}
                          className="form-control"
                          placeholder="Quantity"
                        />
                      </div>
                    </div>

                    <div className="col-lg-6">
                      <label htmlFor="status" className="form-label">
                        Status
                      </label>
                      <select
                        className="form-control"
                        id="status"
                        name="status"
                        onChange={handleInput}
                        value={categoryUser.status}
                        data-placeholder="Select Status"
                      >
                        <option value="">-- Select Status --</option>
                        <option value="Active">Active</option>
                        <option value="Inactive">Inactive</option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>

              <div className="p-3 bg-light mb-3 rounded">
                <div className="row justify-content-end g-2">
                  <div className="col-lg-2">
                    <button
                      type="submit"
                      className="btn btn-outline-secondary w-100"
                      disabled={isSubmitting}
                    >
                      {isSubmitting ? "Saving..." : "Save Change"}
                    </button>
                  </div>
                  <div className="col-lg-2">
                    <Link to="/category-list" className="btn btn-primary w-100">
                      Cancel
                    </Link>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
      {/* End Container Fluid */}
      {/* Footer */}
            <footer className="footer">
              <div className="container-fluid">
                <div className="row">
                  <div className="col-12 text-center">
                    © Venton. Crafted by{" "}
                    <iconify-icon
                      icon="iconamoon:heart-duotone"
                      className="fs-18 align-middle text-danger"
                    />{" "}
                    <Link to="#" className="fw-bold footer-text" target="_blank">
                      Techzaa
                    </Link>
                  </div>
                </div>
              </div>
            </footer>
    </div>
  );
};

export default CategoryCreate;
